import { createStore } from 'vuex'
import axios from 'axios';
import router from './router';
import VuexPersistence from 'vuex-persist';

let url = window.location.origin;

if (process.env.NODE_ENV == 'development') {
    url = 'http://localhost:8000';
}

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
});

export default createStore({
    state: {
        sidebar_drawer: true,
        token: localStorage.getItem('token') || '',
        loader: false,
        user: {},
        release_version: null,
        company_name: '',
        strict_exam_creation: false,
        perscriptum_modules: [{ name: 'Stipel module', status: true },
            { name: 'Teletoets module', status: true },
            { name: 'Testvision module', status: true },
            { name: 'AssessmentQ module', status: true },
            { name: 'Workflow module', status: true },
            { name: 'Planner module', status: true },
            { name: 'Exam statuses module', status: true },
            { name: 'Scheme prices module', status: true }],
        language: 'nl',
        notifyIsOn: true,
        app_url: url + '/api/',
        translations: [],
        panels: {},
        profile_name: null,
        profile_image: null,
        impersonation: {
            name: null,
            original: {
                token: '',
                user: {},
                profile_name: null,
                profile_image: null,
            },
        },
    },
    mutations: {
        setSidebarDrawer(state, payload) {
            state.sidebar_drawer = payload;
        },
        auth_success(state, token) {
            state.token = token;
        },
        impersonation_login(state, payload) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + payload.token;
            state.impersonation = {
                name: payload.user?.name,
                original: {
                    token: state.token,
                    user: state.user,
                    profile_name: state.profile_name,
                    profile_image: state.profile_image,
                },
            };
        },
        impersonation_logout(state, payload) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + payload.token;
            state.impersonation = {
                name: null,
                original: {
                    token: '',
                    user: {},
                    profile_name: null,
                    profile_image: null,
                },
            };
        },
        user(state, user) {
            state.user = user;
            state.profile_name = user.person ? user.person.casual_name : user.email;
            state.profile_image = user.person && user.person.file ? user.person.file.full_path : null;
        },
        logout(state) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.token;
            axios.post(url + '/api/v2/logout').then(response => {
                console.log(response.data);
            })
            state.token = '';
            state.user = null;
            state.profile_image = null;
            state.profile_name = null;
        },
        setLanguage(state, payload) {
            state.language = payload;
        },
        setNotifyIsOn(state, payload) {
            state.notifyIsOn = payload;
        },
        setPanel(state, payload) {
            state.panels[payload.module_name] = payload.value;
        },
        refreshTranslations(state) {
            axios.get(url + '/api/v2/translations-without-login').then(response => {
                state.translations = response.data;
            });
        },
        setProfileName(state, payload) {
            state.profile_name = payload;
        },
        setProfileImage(state, payload) {
            state.profile_image = payload;
        },
        setReleaseVersion(state, payload) {
            state.release_version = payload;
        },
        setCompanyName(state, payload) {
            state.company_name = payload;
        },
        setStrictExamCreation(state, payload) {
            state.strict_exam_creation = payload;
        },
        setPerscriptumModules(state, payload) {
            state.perscriptum_modules = payload;
        },
        setLoader(state, payload) {
            state.loader = payload;
        },
    },
    actions: {
        login({ commit }, auth) {
            return new Promise((resolve, reject) => {
                axios({ url: url + '/api/v2/login', data: auth, method: 'POST' }).then(response => {
                    const token = response.data.token;
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                    commit('auth_success', token);
                    axios.get(url + '/api/user').then(response => {
                        commit('user', response.data);
                        if (response.data.is_candidate || response.data.is_assessor || response.data.is_contact) {
                            router.push('/portal');
                        }
                        else {
                            if(localStorage.getItem('path')) {
                                router.push(localStorage.getItem('path'));
                            }
                            else {
                                router.push('/');
                            }
                        }
                        resolve(response);
                    })
                }).catch(err => {
                    localStorage.removeItem('token');
                    reject(err);
                });
            })
        },
        logout({ commit }) {
            return new Promise((resolve) => {
                commit('logout');
                router.push('/login');
                resolve();
            })
        },
        setLanguage({commit}, data) {
            commit('setLanguage', data);
        },
        setNotifyIsOn({commit}, data) {
            commit('setNotifyIsOn', data);
        },
        refreshTranslations({commit}, data) {
            commit('refreshTranslations', data);
        },
        setPanel({commit}, data) {
            commit('setPanel', data);
        },
        setProfileName({commit}, data) {
            commit('setProfileName', data);
        },
        setProfileImage({commit}, data) {
            commit('setProfileImage', data);
        },
        setSidebarDrawer({commit}, data) {
            commit('setSidebarDrawer', data);
        },
        setReleaseVersion({commit}, data) {
            commit('setReleaseVersion', data);
        },
        setCompanyName({commit}, data) {
            commit('setCompanyName', data);
        },
        setStrictExamCreation({commit}, data) {
            commit('setStrictExamCreation', data);
        },
        setPerscriptumModules({commit}, data) {
            commit('setPerscriptumModules', data);
        },
        setLoader({commit}, data) {
            commit('setLoader', data);
        },
    },
    getters: {
        isLoggedIn: state => !!state.token,
        token: state => state.token,
        appUrl: state => state.app_url,
        getUser: state => state.user,
        getLanguage: state => state.language,
        getNotifyIsOn: state => state.notifyIsOn,
        SidebarDrawer: state => state.sidebar_drawer,
        translate: (state) => (payload) => {
            if (state.translations.length > 0) {
                let result = state.translations.filter(translation => translation.key === payload && translation.language === state.language);
                if (result.length > 0) {
                    return result[0].value;
                }
                return payload;
            } else {
                return payload;
            }
        },
        getPanel: (state) => (payload) => {
            if(state.panels[payload]) {
                return Array.from(state.panels[payload]);
            }
            else {
                return [0];
            }
        },
        profileImage: state => state.profile_image,
        profileName: state => state.profile_name,
        getReleaseVersion: state => state.release_version,
        getCompanyName: state => state.company_name,
        getStrictExamCreation: state => state.strict_exam_creation,
        getPerscriptumModules: state => state.perscriptum_modules,
        getLoader: state => state.loader,
        getImpersonationName: state => state.impersonation.name,
        getImpersonationOriginal: state => state.impersonation.original,
    },
    plugins: [vuexLocal.plugin]
})